import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { MenuIcon, XIcon, ActivityIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const closeMenu = () => setIsMobileMenuOpen(false);
  const navLinks = [{
    name: 'Home',
    path: '/'
  }, {
    name: 'About & Treatments',
    path: '/about'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  return <header className="sticky top-0 z-50 w-full bg-surface border-b border-bordercolor shadow-sm" data-id="element-83">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-84">
        <div className="flex justify-between items-center h-20" data-id="element-85">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 flex-shrink-0" onClick={closeMenu} data-id="element-86">
            <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center text-white" data-id="element-87">
              <ActivityIcon className="w-6 h-6" data-id="element-88" />
            </div>
            <span className="font-bold text-xl text-brandtext tracking-tight" data-id="element-89">
              [CLINIC NAME]
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-90">
            {navLinks.map(link => <NavLink key={link.name} to={link.path} className={({
            isActive
          }) => `text-sm font-medium transition-colors hover:text-primary ${isActive ? 'text-primary' : 'text-brandtext-muted'}`} data-id="element-91">
                {link.name}
              </NavLink>)}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center" data-id="element-92">
            <Link to="/contact" className="inline-flex items-center justify-center px-5 py-2.5 border border-transparent text-sm font-medium rounded-md text-white bg-primary hover:bg-primary-dark transition-colors shadow-sm" data-id="element-93">
              Schedule your tele-health appointment
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="flex md:hidden items-center" data-id="element-94">
            <button type="button" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-brandtext-muted hover:text-primary hover:bg-primary-light focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary transition-colors" aria-expanded={isMobileMenuOpen} data-id="element-95">
              <span className="sr-only" data-id="element-96">Open main menu</span>
              {isMobileMenuOpen ? <XIcon className="block h-6 w-6" aria-hidden="true" data-id="element-97" /> : <MenuIcon className="block h-6 w-6" aria-hidden="true" data-id="element-98" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-99">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.2
      }} className="md:hidden bg-surface border-b border-bordercolor overflow-hidden" data-id="element-100">
            <div className="px-4 pt-2 pb-6 space-y-1" data-id="element-101">
              {navLinks.map(link => <NavLink key={link.name} to={link.path} onClick={closeMenu} className={({
            isActive
          }) => `block px-3 py-3 rounded-md text-base font-medium ${isActive ? 'bg-primary-light text-primary' : 'text-brandtext-muted hover:bg-gray-50 hover:text-primary'}`} data-id="element-102">
                  {link.name}
                </NavLink>)}
              <div className="pt-4 pb-2" data-id="element-103">
                <Link to="/contact" onClick={closeMenu} className="block w-full text-center px-4 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary hover:bg-primary-dark shadow-sm" data-id="element-104">
                  Schedule Appointment
                </Link>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}